module.exports = __webpack_public_path__ + "img/vignettes-asso_0015_adie.3a678e9c.jpg";